import { useRegisterSW } from 'virtual:pwa-register/react'
import posthog from 'posthog-js'
import { Button } from '@/components/ui/button'
import { isPostHogConfigured } from '@/lib/posthog-logs'
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW()
  if (!needRefresh) return null
  return (
    <aside className="update-prompt" role="status">
      <strong>มีแอปเวอร์ชันใหม่</strong>
      <p>บันทึกงานให้เรียบร้อยก่อนอัปเดตและโหลดหน้าใหม่</p>
      <div className="button-row">
        <Button
          size="sm"
          onClick={() => {
            if (isPostHogConfigured)
              posthog.capture('app_update_started', undefined, {
                send_instantly: true,
              })
            void updateServiceWorker(true)
          }}
        >
          อัปเดตและโหลดใหม่
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            if (isPostHogConfigured)
              posthog.capture('app_update_deferred', undefined, {
                send_instantly: true,
              })
            setNeedRefresh(false)
          }}
        >
          ภายหลัง
        </Button>
      </div>
    </aside>
  )
}
